import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatasetDef } from './interface/dataset-definition';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader } from "@angular/material/expansion";
import {MatTableModule} from '@angular/material/table';

import * as DATASET_DATA from '../../../../assets/tests/data/dataset.json' 

@Component({
  selector: 'app-dataset',
  imports: [
      CommonModule,
      MatAccordion,
      MatExpansionPanel,
      MatExpansionPanelHeader,
      MatTableModule
    ],
  templateUrl: './dataset.html',
  styleUrl: './dataset.scss',
})
export class Dataset {

    displayedColumns:string[] = ['name', 'key', 'label', 'type', 'format', 'length', 'settings', 'comments']

    lstDataset: DatasetDef[] = (DATASET_DATA as any).default as DatasetDef[];
}
